import { CheckboxGroupField, type CheckboxGroupFieldProps } from './CheckboxGroupField';
import { Checkbox } from '../base-controls/Checkbox';

export interface CheckboxFieldProps extends Omit<CheckboxGroupFieldProps, 'className' | 'onChange' | 'value' | 'children'> {
	value: boolean;
	onChange: (selected: boolean) => void;
	hideCheckboxLabel?: boolean;
	className?: string;
	fieldClassName?: string;
	labelPrefix?: string;
}

export function CheckboxField({ value, ...props }: CheckboxFieldProps) {
	const onSelectionChange = (value: string[]) => {
		const checkboxValue = value.length === 0 ? false : true;
		props.onChange?.(checkboxValue);
	};

	return (
		<CheckboxGroupField {...props} label={props.label} value={value ? ['selected'] : []} onChange={onSelectionChange}>
			<Checkbox
				value="selected"
				label={props.label}
				labelPrefix={props.labelPrefix}
				hideCheckboxLabel={props.hideCheckboxLabel}
				className={props.fieldClassName}
			/>
		</CheckboxGroupField>
	);
}
